import {useEffect, useState} from 'react';

const measureHeight = (useVisualHeight: boolean | undefined): number => {
    if (__NODEJS__) return 0;
    return useVisualHeight && window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;
};

let timerId: ReturnType<typeof setTimeout>;

/**
 * Hook for get window height
 * @param {boolean} useVisualHeight - use visual viewport height
 * @returns {Function} callback function
 */
export const useWindowHeight = (useVisualHeight?: boolean): number => {
    const [height, setHeight] = useState(measureHeight(useVisualHeight));

    useEffect(() => {
        if (__NODEJS__) return () => {};

        const handleResize = () => setHeight(measureHeight(useVisualHeight));

        window.addEventListener('resize', handleResize);
        window.addEventListener('load', handleResize);
        if (useVisualHeight && window.visualViewport)
            window.visualViewport.addEventListener('resize', handleResize);

        handleResize();
        timerId = setTimeout(handleResize, 3000);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('load', handleResize);
            if (useVisualHeight && window.visualViewport)
                window.visualViewport.removeEventListener('resize', handleResize);
        };
    }, [Boolean(window)]);

    useEffect(() => {
        return () => clearTimeout(timerId);
    }, []);

    return height;
};
